import emailjs from '@emailjs/browser';
import { EMAIL_CONFIG, generateOTP } from '../config/email';
import secureLogger from './secureLoggingService';

class EmailService {
  constructor() {
    // Initialize EmailJS with your public key
    emailjs.init(EMAIL_CONFIG.PUBLIC_KEY);
  }

  // Send password reset OTP email
  async sendPasswordResetOTP(email) {
    try {
      const otp = generateOTP();
      
      // EmailJS template parameters - simplified for your template
      const templateParams = {
        to_email: email,
        otp: otp
      };

      secureLogger.info('Sending email with EmailJS', {
        serviceId: EMAIL_CONFIG.SERVICE_ID,
        templateId: EMAIL_CONFIG.TEMPLATE_ID,
        email: email
      });

      // Send email using EmailJS
      const response = await emailjs.send(
        EMAIL_CONFIG.SERVICE_ID,
        EMAIL_CONFIG.TEMPLATE_ID,
        templateParams
      );

      secureLogger.info('EmailJS response', response);

      if (response.status === 200) {
        return {
          success: true,
          otp: otp,
          message: 'OTP sent successfully to your email'
        };
      } else {
        throw new Error(`EmailJS returned status: ${response.status}`);
      }
    } catch (error) {
      secureLogger.error('EmailJS sending error', error);
      return {
        success: false,
        error: `Failed to send OTP email: ${error.message}`
      };
    }
  }

  // Alternative method using a simple email service (for demo purposes)
  async sendPasswordResetOTPDemo(email) {
    try {
      const otp = generateOTP();
      
      // For demo purposes, we'll simulate sending an email
      // In a real application, you would integrate with a service like:
      // - SendGrid
      // - Mailgun
      // - AWS SES
      // - Nodemailer with SMTP
      
      secureLogger.info('Demo Email Service', { to: email });
      // SECURITY: Remove OTP logging in production
      if (process.env.REACT_APP_DEBUG_MODE === 'true') {
        secureLogger.otp('Demo OTP generated', { email, otp });
      }
      secureLogger.info('This is demo mode - no real email was sent');
      
      // Simulate API call delay
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      return {
        success: true,
        otp: otp,
        message: `OTP sent successfully to ${email} (Demo mode - check console for OTP)`
      };
    } catch (error) {
      secureLogger.error('Demo email error', error);
      return {
        success: false,
        error: 'Failed to send OTP email'
      };
    }
  }
}

const emailService = new EmailService();
export default emailService;
